import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { ReactNode } from "react";

type Side = "top" | "bottom" | "left" | "right";

export function IconTooltip({
  label,
  children,
  side = "top",
  delayDuration = 250,
}: {
  label: ReactNode;
  children: ReactNode;
  side?: Side;
  delayDuration?: number;
}) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side={side}
          className="bg-gray-800 text-gray-200 text-xs border-gray-600"
        >
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
